export function gen_uniq_str(length: number) {
    const chrs = 'abdehkmnpswxzABDEFGHKMNPQRSTWXZ123456789';
    let str = '';
    for (var i = 0; i < length; i++) {
        var pos = Math.floor(Math.random() * chrs.length);
        str += chrs.substring(pos,pos+1);
    }
    return str;
}

export function gen_uniq_number(min: number, max: number) {
    return Math.floor(Math.random() * (max - min)) + min
}

export function isURL(str: string) {
    try {
      new URL(str);
      return true;
    } catch {
      return false;
    }
  }


export function form_to_json<T>(formData: FormData): T {
var object = {};
formData.forEach((value, key) => {
    if(!Reflect.has(object, key)){
        object[key] = value;
        return;
    }
    if(!Array.isArray(object[key])){
        object[key] = [object[key]];    
    }
    object[key].push(value);
});
return object as T
}

export async function copyTextClipboard(text: string, callbackResolve?: () => any, callbackError?: (e: Error) => any) {
    try {
        await navigator.clipboard.writeText(text)
        if(callbackResolve) callbackResolve()
    } catch (error) {
        if(callbackError) callbackError(error)
    }
     

}